import { useState, useEffect } from 'react';

export const useFormFactor = (): 'desktop' | 'mobile-portrait' | 'mobile-landscape' => {
  const [ff, setFf] = useState<'desktop' | 'mobile-portrait' | 'mobile-landscape'>('desktop');
  useEffect(() => {
    const compute = () => {
      const isPortrait = window.matchMedia('(orientation: portrait)').matches;
      // Use the SHORT side of the viewport to classify handhelds, not just width.
      // This works better for high-res phones in landscape where innerWidth can be large.
      const shortSide = Math.min(window.innerWidth, window.innerHeight);
      // Coarse pointer is a strong signal for touch-only handhelds
      const isCoarse = window.matchMedia('(pointer: coarse)').matches;
      // Fallback media query for small viewports (covers some desktop browser edge cases)
      const isSmallViewport = window.matchMedia('(max-width: 1024px)').matches;

      // Consider device a "phone" when it has a coarse pointer AND a small short side.
      // Threshold 700px chosen to include big phones while excluding most tablets.
      const isPhone = (isCoarse && shortSide <= 700) || (shortSide <= 600) || isSmallViewport && shortSide <= 700;

      if (isPhone) {
        return setFf(isPortrait ? 'mobile-portrait' : 'mobile-landscape');
      }
      return setFf('desktop');
    };
    compute();
    window.addEventListener('resize', compute);
    // Listen for orientation and pointer media query changes, which may not always trigger resize
    const mqp = window.matchMedia('(orientation: portrait)');
    const mqc = window.matchMedia('(pointer: coarse)');
    const onChange = () => compute();
    mqp.addEventListener?.('change', onChange);
    mqc.addEventListener?.('change', onChange);
    return () => {
      mqp.removeEventListener?.('change', onChange);
      mqc.removeEventListener?.('change', onChange);
      window.removeEventListener('resize', compute);
    };
  }, []);
  return ff;
};